import { render } from "./FullScreenLoading.vue?vue&type=template&id=0151a662"
import script from "./FullScreenLoading.vue?vue&type=script&lang=js"
export * from "./FullScreenLoading.vue?vue&type=script&lang=js"
script.render = render

export default script